import { useEffect, useState } from "react";
import { brandColors as colors } from "@/lib/palette";
import { api } from "@/lib/api";
import FavoritesPage, { type FavoriteItem } from "@/components/pages/FavoritesPage";

export function Favorites() {
  const [items, setItems] = useState<FavoriteItem[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ items: FavoriteItem[] }>("/api/favorites")
      .then((r) => setItems(r.items))
      .catch((e) => setErr(e instanceof Error ? e.message : "Failed to load favorites"));
  }, []);

  if (err) {
    return (
      <div style={{ padding: "4rem 2rem", color: colors.navy }}>
        <p style={{ color: colors.berryRose, fontWeight: 600 }}>{err}</p>
      </div>
    );
  }

  return <FavoritesPage items={items ?? []} showSiteChrome={true} loading={items === null} />;
}
